import { render, staticRenderFns } from "./BacksearchList.vue?vue&type=template&id=3ac4c375&scoped=true"
import script from "./BacksearchList.vue?vue&type=script&lang=js"
export * from "./BacksearchList.vue?vue&type=script&lang=js"
import style0 from "./BacksearchList.vue?vue&type=style&index=0&id=3ac4c375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac4c375",
  null
  
)

export default component.exports